import { IconType } from '../icon';

export const radioSelectedIconConfig = {
  type: IconType.NgZorro,
  name: 'check'
};
